/**
 * Siltcon Auréa: video in de productgalerij.
 * Speelt automatisch af zonder geluid, in een lus en zonder knoppen, maar alleen als de video in beeld is.
 * De video laadt pas op dat moment (preload="none").
 */
class AureaVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      },
      { threshold: [0, 0.5] }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('aurea-video')) {
  customElements.define('aurea-video', AureaVideo);
}
